module.exports = __webpack_public_path__ + "static/img/5弹簧与气压同步作用型管路缩口调节系统.c9a08cbb.jpg";